import {IRawChat} from '../../RawChatsStore/RawChat';
import getUnreadCount from './getUnreadCount';

export default function chatIsUnread(rawChat: IRawChat): boolean {
  return getUnreadCount(rawChat) > 0;
}